import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

// TransomOption — shown when LiteCollection = 'CustomGlassCutoutOptions'
const OPTIONS = [
  { value: 'None',                    label: 'None'                      },
  { value: 'Clear',                   label: 'Clear'                     },
  { value: 'Sandblasted',             label: 'Sandblasted'               },
  { value: 'Screen',                  label: 'Screen'                    },
  { value: 'RainNiagara',             label: 'Rain/Niagara'              },
  { value: 'MistLite',                label: 'Mist Lite'                 },
  { value: 'Cutout',                  label: 'Cutout'                    },
  { value: 'DealerSuppliedGlassLites', label: 'Dealer Supplied Glass Lites' },
];

const TransomOption = ({ value = { value: '', label: '' }, onChange, disabled = false }) => {
  const [selected, setSelected] = useState(value?.value || '');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdTransomOption">Option</label>
      <select id="SdTransomOption" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default TransomOption;
